import Stack from '@mui/material/Stack'
import { useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import { CopyButton } from './CopyButton'

export function CopyText({
  onCopy,
  text,
  caption,
}: {
  onCopy?: () => void
  onClose?: () => void
  text: string
  caption: string
}) {
  const theme = useTheme()

  return (
    <Stack
      sx={{
        w: 1,
        borderRadius: 1,
        bgcolor: 'background.neutral',
        boxShadow: theme.customShadows.card,
      }}
      data-testid="survey-copy-review">
      <Stack direction="row" justifyContent="space-between" px={2} py={1} alignItems="center" gap={2}>
        <Typography variant="caption">{caption}</Typography>
        <CopyButton text={text} onCopy={onCopy} />
      </Stack>
      <Stack
        sx={{
          bgcolor: 'background.paper',
          borderBottomLeftRadius: 8,
          borderBottomRightRadius: 8,
          p: 2,
        }}>
        <Typography variant="body1">{text}</Typography>
      </Stack>
    </Stack>
  )
}
